module.exports = "/images/badge.svg?82e6ea02db418dbc27e02c3ff4fd720e";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/badge.svg
// module id = aBih
// module chunks = 0